import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Policies() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [activePolicy, setActivePolicy] = useState(null)
  const [signed, setSigned] = useState([])
  const [sigName, setSigName] = useState('')

  const policies = [
    {
      id: 0,
      title: 'Employee Handbook 2025',
      version: '2025.1',
      issued: 'Jan 1, 2025',
      requiresSig: true,
      body: `1. Welcome Statement\nDemo Company Co. is committed to creating a respectful, inclusive, and productive workplace for all employees. This handbook outlines the policies and expectations that guide our work together.\n\n2. Code of Conduct\nAll employees are expected to treat colleagues, clients, and partners with professionalism and respect. Harassment, discrimination, or intimidation of any kind will not be tolerated.\n\n3. Work Hours & Attendance\nStandard hours are Monday–Friday, 8:00am–4:30pm unless otherwise specified by your department manager. All schedule changes must be submitted through the portal at least 48 hours in advance.\n\n4. Time Off & PTO\nFull-time employees accrue 1.25 days of PTO per month, totaling 15 days annually. All time off requests must be submitted through the portal and are subject to manager approval.\n\n5. Confidentiality\nEmployees must maintain the confidentiality of all company information, client data, and internal communications.`,
    },
    {
      id: 1,
      title: 'Parking Policy — May 2025 Update',
      version: '1.0',
      issued: 'Mar 25, 2025',
      requiresSig: true,
      body: `Effective May 1, 2025, all staff members who park in the company lot are required to register their vehicle(s) with the front office.\n\nRegistration forms are available at the front desk or in the Document Library in this portal.\n\nFailure to register by May 1 may result in your vehicle being towed at your expense.\n\nQuestions? Reach out to admin at info@democompany.co.`,
    },
    {
      id: 2,
      title: 'Data Privacy & Security Policy',
      version: '2.1',
      issued: 'Jun 1, 2024',
      requiresSig: false,
      body: `All employees are responsible for protecting the personal data of clients, colleagues, and the organization.\n\nThis includes:\n• Not sharing passwords with anyone\n• Locking your screen when stepping away\n• Reporting any suspected data breach to your supervisor immediately\n• Not storing sensitive data on personal devices\n\nViolations of our data policy may result in disciplinary action up to and including termination.`,
    },
  ]

  function handleSign() {
    if (!sigName.trim()) { alert('Please type your full name to sign.'); return }
    setSigned(s => [...s, activePolicy])
    setSigName('')
  }

  const selected = activePolicy !== null ? policies.find(p => p.id === activePolicy) : null
  const needsSig = policies.filter(p => p.requiresSig && !signed.includes(p.id)).length

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Policies</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Your signed documents — review and sign where required</p>
        </div>
        {needsSig > 0 && (
          <span style={{padding:'4px 12px',borderRadius:20,fontSize:11,fontWeight:600,background:'rgba(160,57,43,0.1)',color:'#A0392B',border:'1px solid rgba(160,57,43,0.2)'}}>
            {needsSig} requiring signature
          </span>
        )}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'260px 1fr',gap:14,minHeight:500}}>

        {/* Policy list */}
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',alignSelf:'start'}}>
          {policies.map((p,i) => {
            const isSigned = signed.includes(p.id)
            return (
              <div key={p.id} onClick={()=>{setActivePolicy(p.id);setSigName('')}}
                style={{padding:'14px 16px',borderBottom:i<policies.length-1?'1px solid #EDE6DA':'none',cursor:'pointer',borderLeft:activePolicy===p.id?'3px solid #B8734A':'3px solid transparent',background:activePolicy===p.id?'rgba(184,115,74,0.06)':'transparent'}}>
                <div style={{fontSize:12,fontWeight:600,color:activePolicy===p.id?accent:'#2B2B2B',marginBottom:3}}>{p.title}</div>
                <div style={{fontSize:10,color:'#8A9E8A',marginBottom:6}}>v{p.version} · Issued {p.issued}</div>
                {p.requiresSig ? (
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,fontWeight:600,background:isSigned?'rgba(74,124,89,0.1)':accentBg,color:isSigned?'#4A7C59':accent}}>
                    {isSigned ? '✓ Signed' : 'Signature Required'}
                  </span>
                ) : (
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,fontWeight:600,background:'rgba(107,125,107,0.08)',color:'#6B7D6B'}}>Read Only</span>
                )}
              </div>
            )
          })}
        </div>

        {/* Policy detail */}
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column'}}>
          {selected ? (
            <>
              <div style={{padding:'16px 20px',borderBottom:'1px solid #EDE6DA'}}>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:'#2B2B2B',fontWeight:600,marginBottom:4}}>{selected.title}</div>
                <div style={{display:'flex',gap:10,alignItems:'center'}}>
                  <span style={{fontSize:11,color:'#8A9E8A'}}>Version {selected.version}</span>
                  <span style={{fontSize:11,color:'#8A9E8A'}}>·</span>
                  <span style={{fontSize:11,color:'#8A9E8A'}}>Issued {selected.issued}</span>
                  {selected.requiresSig && (
                    <span style={{fontSize:10,padding:'2px 7px',borderRadius:8,fontWeight:600,background:signed.includes(selected.id)?'rgba(74,124,89,0.1)':accentBg,color:signed.includes(selected.id)?'#4A7C59':accent}}>
                      {signed.includes(selected.id) ? '✓ Signed' : 'Signature Required'}
                    </span>
                  )}
                </div>
              </div>
              <div style={{flex:1,padding:'20px',overflowY:'auto'}}>
                <div style={{background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,padding:'16px',marginBottom:selected.requiresSig?20:0,maxHeight:280,overflowY:'auto'}}>
                  {selected.body.split('\n\n').map((para,i) => (
                    <p key={i} style={{fontSize:13,color:'#4A4A4A',lineHeight:1.8,marginBottom:10,whiteSpace:'pre-line'}}>{para}</p>
                  ))}
                </div>

                {selected.requiresSig && (
                  signed.includes(selected.id) ? (
                    <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'14px 16px'}}>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5.5 9l2.5 2.5L12.5 6" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
                      <div>
                        <div style={{fontSize:13,color:'#4A7C59',fontWeight:600}}>Policy signed</div>
                        <div style={{fontSize:11,color:'#4A7C59',opacity:0.8}}>Recorded on April 2, 2025</div>
                      </div>
                    </div>
                  ) : (
                    <div style={{border:'2px dashed #D9C3A3',borderRadius:8,padding:'16px'}}>
                      <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:10,textAlign:'center'}}>
                        Type your full legal name to acknowledge and sign
                      </div>
                      <input
                        value={sigName}
                        onChange={e=>setSigName(e.target.value)}
                        placeholder="Your full legal name"
                        style={{width:'100%',padding:'10px 14px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',textAlign:'center',marginBottom:12}}
                      />
                      <button onClick={handleSign} style={{width:'100%',padding:'10px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                        Sign Policy →
                      </button>
                    </div>
                  )
                )}
              </div>
            </>
          ) : (
            <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'3rem',textAlign:'center'}}>
              <div style={{width:48,height:48,borderRadius:'50%',background:'#F7F2EB',border:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:12}}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="4" y="2" width="12" height="16" rx="2" stroke="#D9C3A3" strokeWidth="1.5"/><path d="M7 7h6M7 11h4" stroke="#D9C3A3" strokeWidth="1.25" strokeLinecap="round"/></svg>
              </div>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1rem',color:'#2B2B2B',marginBottom:4}}>Select a policy to review</div>
              <div style={{fontSize:12,color:'#8A9E8A'}}>Choose from the list on the left</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

